import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import BtnGroup from "../baseui/buttons/BtnGroup";

import { Icon } from "@iconify/react";
import Caption from "../baseui/Caption";
import { useSelector } from "react-redux";
import { userSelector } from "../../redux/authSlice";
const PageInfo = ({ get }) => {
  const user = useSelector(userSelector);

  return (
    <>
      <div className="pageTitle">
        <Row className="align-items-center">
          <Col lg="12">
            <Caption
              heading1="Dashboard"
              leadText={`Welcome back, ${user?.firstName} ${user?.lastName}!`}
            />
          </Col>
          <Col lg="3" className="text-end">
            {/*   <BtnGroup
              getSurveys={get}
              classes="btn cta-group cta-primary"
              btnText="Add New"
              icon={<Icon icon="iconoir:nav-arrow-right" />}
            />*/}
          </Col>
        </Row>
      </div>
    </>
  );
};

export default PageInfo;
